export const BACKGROUND_VIDEO_URL =
	'https://resources-cdn.mission.io/public/videos/backgroundv2.webm'

export const BACKGROUND_VIDEO_URL_NO_LOGO =
	'https://resources-cdn.mission.io/public/videos/background.webm'

export const CCM_SUCCESS_VIDEO_URL =
	'https://resources-cdn.mission.io/public/videos/CCMSuccess.webm'

export const CCM_FAIL_VIDEO_URL =
	'https://resources-cdn.mission.io/public/videos/CCMFail.webm'

export const STATIC_BACKGROUND_URL =
	'https://resources-cdn.mission.io/simulations/general/static-background.png'
